import React, { useCallback, useEffect, useState } from "react";
import {
  LoyaltyContent,
  LoyaltyIndicatorBoxWrapper
} from "./LoyaltyIndicatorBoxWrapper";
import { MessageBrokerUtils, TrackingUtils } from "../../utils";
import { Channel, Topic } from "../../constants";
import { EmptyComponent } from "../common/EmptyComponent";
import { useScript } from "../../hooks";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import PropTypes from "prop-types";
import LoyaltyContentSkeleton from "./LoyaltyContentSkeleton";
import { useFeature } from "../../hooks/useFeature";
import { AppFeatures } from "../../constants/featureFlags";

const LoyaltyIndicatorBox = props => {
  const { trackingInfo, onClick } = props;

  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const [loyaltyData, setLoyaltyData] = useState(undefined);
  const isLoyaltyEnabled = useFeature(AppFeatures.LOYALTY_INDICATION);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  useEffect(() => {
    const initLoyalty = (data, envelope) => {
      if (!data || !envelope || envelope.headers.publisher === "UAA") return;

      setLoyaltyData(data);
    };

    const loyaltySubscription = MessageBrokerUtils.subscribe({
      channel: Channel.LOYALTY_INDICATION,
      topic: Topic.INIT_LOYALTY_INDICATION,
      callback: initLoyalty
    });

    MessageBrokerUtils.publish({
      channel: Channel.LOYALTY_INDICATION,
      topic: Topic.INIT_LOYALTY_INDICATION,
      headers: { publisher: "UAA" }
    });

    return () => {
      loyaltySubscription?.unsubscribe();
    };
  }, []);

  const loyaltyIndicatorClick = useCallback(() => {
    TrackingUtils.sendAnalytics({
      ...trackingInfo,
      dataLabel: "Loyalty"
    });
    onClick();
  }, [trackingInfo, onClick]);

  const { loaded } = useScript(loyaltyData, isAuthenticated);

  if (!isLoyaltyEnabled) return null;

  return loyaltyData && isAuthenticated ? (
    <LoyaltyIndicatorBoxWrapper
      isMobile={isMobile}
      onClick={loyaltyIndicatorClick}
    >
      <LoyaltyContent
        id="rl-loyalty-indication"
        data-testid="uc-loyalty-indication"
        isLoaded={loaded}
      />
      <LoyaltyContentSkeleton isMobile={isMobile} isLoaded={loaded} />
    </LoyaltyIndicatorBoxWrapper>
  ) : (
    <EmptyComponent />
  );
};

LoyaltyIndicatorBox.propTypes = {
  trackingInfo: PropTypes.object,
  onClick: PropTypes.func
};
export default React.memo(LoyaltyIndicatorBox);
